export default {
    LOAD_PRODUCT_CATEGORIES (state, productcategories) {
        state.items = productcategories
    }
}